import { Stack, type StackProps } from '../Layout'

export const EmptyCard = (props: StackProps) => (
  <Stack spacing={1} boxShadow={theme => theme.elevation.card2} width={1} px={4} py={2} borderRadius={6} {...props} />
)
